import { API_IDS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { IHttpAdapter } from '../../../lib/core/entities/iHttpAdapter';
import { IUserIdentityRepository } from '../../core/repositories/interfaces/iUserIdentityRepository';
import { container } from '../../DataDomain';
import { ISubscriptionStatusResponse } from '../../entity/interface/iSubscriptionStatus';
import { IApiPathManager } from '../config/ApiPathManager';

class UserIdentityRepository implements IUserIdentityRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    private get productKey(): string {
        return process.env['NX_PUBLIC_PRODUCT_KEY'] || 'stc-tv';
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getSubscriptionStatus(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatusResponse> {
        const response = await this.http.get<ISubscriptionStatusResponse>(
            this.apiPathManager.getPath(API_IDS.USER_SUBSCRIPTION_STATUS_NEW),
            {
                withCredentials: false,
                headers: {
                    Authorization: token,
                    identityToken: identityToken,
                },
                params: {
                    apikey: apiKey,
                    userName: username,
                    productKey: this.productKey,
                },
            }
        );
        return response.data;
    }
}

export default UserIdentityRepository;
